import { createFileRoute } from "@tanstack/react-router";
import { LiderListPage } from "@/features/sys-premiowy/lider-list-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/raporty/system-premiowy/lider/")({
	component: LiderListPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.sys-premiowy-lider",
			location.pathname,
		);
	},
});
